import { confirm } from "./confirm.tsx";

export type DangerousActionKind =
	| "destructive"
	| "irreversible"
	| "simulation";

type BaseDangerousConfirmOptions = {
	cancelText?: string;
	kind?: DangerousActionKind;
	okText?: string;
	variant?: string;
};

export const getDangerousConfirmButtonVariant = (kind?: DangerousActionKind) =>
	kind === "destructive" || kind === "irreversible" ? "danger" : "primary";

export function confirmDangerousAction(
	message: string,
	options: BaseDangerousConfirmOptions & {
		defaultValue: string;
	},
): Promise<string | null>;

export function confirmDangerousAction(
	message: string,
	options?: BaseDangerousConfirmOptions & {
		defaultValue?: undefined;
	},
): Promise<boolean>;

export function confirmDangerousAction(
	message: string,
	{
		cancelText,
		defaultValue,
		kind,
		okText,
		variant,
	}: BaseDangerousConfirmOptions & {
		defaultValue?: string;
	} = {},
): Promise<boolean | string | null> {
	if (defaultValue !== undefined) {
		return confirm(message, {
			cancelText,
			defaultValue,
			okButtonVariant: getDangerousConfirmButtonVariant(kind),
			okText,
			variant,
		});
	}

	return confirm(message, {
		cancelText,
		okButtonVariant: getDangerousConfirmButtonVariant(kind),
		okText,
		variant,
	});
}
